import './AppLoading.css'
import Spinner from './assets/cloudinaryLoader.svg'
import Error from './assets/cloudinaryError.svg'

export default function AppLoading(props) {
    return (
        <>
            { !props.error && <div className={'spinner-wrap'}>
                <img
                    width="400"
                    src={Spinner}
                 alt={'Loading'}/>
            </div> }
            { props.error && <>
             <div className={'spinner-wrap'}>
                <img
                    width="400"
                    src={Error}
                    alt={'Error'}/>
            </div>
            <div className={'spinner-wrap'}>Unable to connect to Cloudinary. Please contact</div>
            <div className={'contact-support'}> <a href="https://support.cloudinary.com/hc/en-us/requests/new">Cloudinary support</a></div>
            </>
            }
        </>
    )
}